<template>
  <div class="project-input" ref="projectInput" :class="[{'active': isActive, 'mini': mini == ''}]">
    <template v-if="type == 'phone'">
      <div class="area-code" @click="showPicker = true">
        <div class="text">+{{areacode}}</div>
        <div class="icon">
          <svg-icon icon-class="triangle"></svg-icon>
        </div>
      </div>
    </template>
    <input ref="projectInput" @keyup.enter="onSubmit" :class="[{'isPw': type == 'password' && inputValue}]" v-model="inputValue" :placeholder="placeholder" @focus="focus" @blur="blur" @change="change" :type="inputType" :disabled="isDisabled" />
    <template v-if="type == 'select'">
      <div class="icon">
        <svg-icon icon-class="triangle"></svg-icon>
      </div>
    </template>
    <template v-if="clearShow">
      <div class="close icon" v-show="isActive && inputValue" @click="clearValue()">
        <img v-if="clear == '2'" src="@/assets/img/close2.png" />
        <img v-else src="@/assets/img/input_close.png" />
      </div>
    </template>
    <template v-if="type == 'password'">
      <div class="eye icon" v-show="isActive" @click="setShow()">
        <img v-show="!showPassword" src="@/assets/img/log_icon_eyeoff.png" />
        <img v-show="showPassword" src="@/assets/img/log_icon_eye.png" />
      </div>
    </template>
    <slot></slot>

    <sd-picker :show.sync="showPicker" :data="areaCodeData" :index="codeIndex" :title="$t('text.perfect_qwer')" @confirm="(val) => { areacode = val }"></sd-picker>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {get} from 'lodash';
import sdPicker from "./picker.vue";

export default {
    name: "sd-input",
    components: { sdPicker },
    model: {
        prop: 'modelValue', // 默认是value
        event: 'modelInput', // 默认是input
    },
    props: {
        modelValue: String | Number,
        placeholder: String | Number,
        type: {
            type: String,
            default: "text"
        },
        clear: false,
        mini: String,
        disabled: String | Boolean,
        code: String,
        autoFocus: String
    },

    data() {
        return {
            codeIndex: 0,
            inputValue: this.modelValue,
            isActive: false,
            showPassword: false,
            inputType: this.type,

            showPicker: false,
            areacode: ''
        }
    },

    computed: {
        ...mapState({
            phonecode: state => state.common.phonecode,
            dataconter: (state) => state.common.dataconter,
            datacenteruuid: (state) => state.common.datacenteruuid,
        }),

        clearShow() {
            let b = this.clear === ''? true : !!this.clear
            return b;
        },

        isDisabled() {
            if(this.type == 'select') {
                return true
            }
            if(this.disabled || this.disabled == '') {
                return true
            }
            return false;
        },

        areaCodeData() {
            const arr = (Array.isArray(this.phonecode) ? this.phonecode : []).map(item => {
                return {
                    name: `+${item.areaCode} ${item.areaName}`,
                    value: item.areaCode
                }
            })
            let dataconterIndex = 0
            let dataconterItem = this.dataconter.find(item => item.tenantId == this.datacenteruuid)
            if (dataconterItem&&dataconterItem.sortName) {
                dataconterIndex = this.phonecode.findIndex(item => item.sortname == dataconterItem.sortName)
            }
            
            let index = 0;
            if(this.code) {
                index = arr.findIndex(i => {
                    return i.value == this.code
                })
            }
            this.codeIndex = index || dataconterIndex;
            this.areacode = get(arr[index || dataconterIndex], 'value');
            return arr;
        }
    },

    watch: {
        inputValue(val) {
            this.$emit("modelInput", val)
        },
        modelValue(val) {
            this.inputValue = val;
        },
        areacode(val) {
            this.$emit("getareacode", val)
        }
    },

    mounted() {
        if(this.autoFocus == '') {
            // this.setFocus()
        }
    },

    methods: {
        setFocus() {
            let projectInput = this.$refs.projectInput;
            console.log(projectInput)
            let inputs = projectInput.getElementsByTagName("input");
            console.log(inputs);
        },

        focus() {
            this.$emit("focus");
            setTimeout(() => {
                this.isActive = true;
            });
        },

        blur() {
            this.$emit("blur");
            setTimeout(() => {
                this.isActive = false;
            });
        },

        change() {
            this.$emit("change");
        },

        clearValue() {
            this.inputValue = "";
            this.$nextTick(() => {
                this.$refs.projectInput.focus();
                this.focus();
            })
        },

        setShow() {
            this.showPassword = !this.showPassword;
            this.inputType = this.showPassword? "text" : "password";
            this.$nextTick(() => {
                this.$refs.projectInput.focus();
                this.focus();
            })
        },

        onSubmit() {
            this.$emit("enter")
        }
    }
}
</script>

<style lang="scss" scoped>
    .project-input {
        height: 48px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        margin-bottom: 20px;
        box-sizing: border-box;
        font-size: 14px;
        display: flex;
        align-items: center;

        &.active {
            border-color: #E22F25;
        }

        input {
            flex: 1;
            color: #484C54;
            margin: 0 16px;
            outline: none;

            &:disabled {
                background-color: transparent;
                cursor: no-drop;
            }
        }

        input[type="password"] {
            letter-spacing: 5px;

            &.isPw {
                font-size: 24px;
            }
        }

        .icon {
            margin-right: 16px;
        }

        .close {
            width: 16px;
            height: 16px;
        }

        .eye {
            width: 24px;
            height: 24px;
        }

        /* WebKit browsers */
        ::-webkit-input-placeholder {
            color: rgba(72, 76, 84, 0.29)
        }

        .area-code {
            display: flex;
            padding: 0 10px 0 16px;
            border-right: 1px solid #E5E5E5;

            .text {
                width: 46px;
                text-align: left;
                color: #484C54;
                font-size: 14px;
                line-height: 18px;
            }

            .icon {
                margin-right: 0;
            }
        }

        &.mini {
            height: 40px;
            border-width: 1px;
            border-radius: 3px;

            input {
                margin: 0 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/input.vue